import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Stack, Typography } from '@mui/material'

import SitesSelection from 'packages/ui/Arborist/components/SitesSelection'

const Accounts = ({ accounts, hasAlertPerimeter }) => {
  const { t } = useTranslation()
  const accountsWithoutParent = useMemo(() => {
    return accounts.filter(account => {
      if (!account.is_site) {
        return false
      } else if (!account.sf_parent_id) {
        return true
      }
      return accounts.findIndex(({ sf_id }) => sf_id === account.sf_parent_id) === -1
    })
  }, [accounts])

  const selection = useMemo(() => {
    if (!accountsWithoutParent.length) {
      return accounts
    }
    const accountParent = {
      id: 'ghost',
      sf_id: 'ghost',
      name: t('account_without_parent'),
      hierarchie: ['ghost'],
      has_error: true
    }
    const newAccounts = accounts.map(account => {
      const children = accountsWithoutParent.find(({ sf_id }) => account.sf_id === sf_id)
      return children
        ? {
          ...account,
          sf_parent_id: 'ghost',
          hierarchie: ['ghost', account.hierarchie.at(-1)],
        }
        : account
    })
    return [accountParent, ...newAccounts]
  }, [t, accounts, accountsWithoutParent])
  return (
    <Stack flex={1}>
      {
        hasAlertPerimeter && (
          <Typography sx={{fontSize: 13}}>{t('advertisements.perimeter_alert')}</Typography>
        )
      }
      <SitesSelection accounts={selection} />
    </Stack>


  )
}
export default Accounts
